import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose, branch, renderComponent } from 'recompose';

import { isLogin, myProfile } from '../../Redux/user-profile/selectors';
import { logout } from '../../Redux/user-profile/actions';

import { LoginButton } from '../../Components/MenuItem/AuthButton';

import MyProfileButton from '../MyProfileButton';

const mapStateToProps = state => ({
  isLogin: isLogin(state),
  myProfile: myProfile(state),
});

export default compose(
  connect(
    mapStateToProps,
    { logout }
  ),
  withRouter,
  branch(props => !props.isLogin, renderComponent(LoginButton))
)(MyProfileButton);
